import { defineStore } from "pinia";
import { ref, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "./user.store.js";
import { useTitle } from "@vueuse/core";
import { DEFAULT_PAGE_LIMIT } from "../helpers/pagination.js";

export const useUiStore = defineStore("ui", () => {
  const router = useRouter();
  const route = useRoute();
  const topbarTitle = ref("");
  const fireworks = ref(false);
  const timer = ref(false);
  const userStore = useUserStore();
  const limit = ref(DEFAULT_PAGE_LIMIT);
  watch(
    () => userStore.user,
    (user) => {
      limit.value = user?.limit ?? DEFAULT_PAGE_LIMIT;
    },
    { immediate: true, flush: "sync" },
  );
  const selection = ref([]);
  const actions = ref([]);
  const showPopover = ref(true);

  const celebrating = computed(() => !!fireworks.value);

  const pageTitle = computed(() => {
    return topbarTitle.value ? `Dubrink - ${topbarTitle.value}` : "Dubrink - Intelligent Trade Compliance";
  });

  useTitle(pageTitle);

  const clear = () => {
    selection.value = [];
    actions.value = [];
    showPopover.value = true;
  };

  const celebrate = () => {
    fireworks.value = true;
    clearTimeout(timer.value);
    timer.value = setTimeout(() => (fireworks.value = false), 5000);
  };

  const paginate = (e) => {
    router.push({ query: { ...route.query, page: e.page + 1 } });
  };

  const getPaginationState = (page) => (page ? Number(page) - 1 : 0) * limit.value;

  return {
    celebrate,
    celebrating,
    topbarTitle,
    selection,
    actions,
    clear,
    showPopover,
    limit,
    getPaginationState,
    paginate,
  };
});
